module.exports = __webpack_public_path__ + "media/images/salespartner/merit03-f96d5ef9b6e0ad5a38d0bb7dca599a00.svg";